<div hisDdKey="fs.res.patent.PriorityPatent.inventors" #dDInventors>
	<p-panel header="{{dDInventors.ddLabeltext | hisUi}}">
	
	     <!-- #anchor dynamic field container -->
	     <ng-template #dynamicFieldContainer></ng-template>
	
	     <!-- no record found -->
	     <div *ngIf="!patent.priorityPatent">
            <div #content [class]="dDInventors.required ? 'requireMessage' : 'infoMessage'"
                *ngIf="patent.inventors && patent.inventors.length === 0">
                <span [innerHTML]="'fs.res.patent.noAssignedInventors' | hisUi"></span>
            </div>
             <div class="clearer"></div>
            <button (click)="createInventor('INTERN')" hisImage="USER_ADD" class="transparent">
                <span>{{'fs.res.patent.assignInternalPerson'|hisUi}}</span>
            </button>
            <div class="clearer"></div>
            <button (click)="createInventor('EXTERN')" hisImage="USER_EXTERNAL" class="transparent">
                <span>{{'fs.res.patent.assignExternalPerson'|hisUi}}</span>
            </button>
	     </div>
	     <br/>
	       
	     <div *ngIf="patent.inventors && patent.inventors.length > 0; else priorityPatentInventors">
	         <p-table #content [value]="patent.inventors">
	             <ng-template pTemplate="header">
	                 <tr>
	                     <th [pSortableColumn]="'person.surname'">
	                         {{ 'fs.res.patent.Patent.inventor.surname' | hisUi }}
	                         <p-sortIcon *ngIf="patent.inventors.length > 1" [field]="'person.surname'"></p-sortIcon>
	                     </th>
	                     <th [pSortableColumn]="'person.firstname'">
	                         {{ 'fs.res.patent.Patent.inventor.firstname' | hisUi }}
	                         <p-sortIcon *ngIf="patent.inventors.length > 1" [field]="'person.firstname'"></p-sortIcon>
	                     </th>
	                     <th [pSortableColumn]="'organization.text'">
	                         {{ 'fs.res.patent.Patent.inventor.organizationUnit' | hisUi }}
	                         <p-sortIcon *ngIf="patent.inventors.length > 1" [field]="'organization.text'"></p-sortIcon>
	                     </th>
	                     <th [pSortableColumn]="'percentage'" class="header-no-wrap">
	                         {{ 'fs.res.patent.Patent.inventor.percentage' | hisUi }}
	                         <p-sortIcon *ngIf="patent.inventors.length > 1" [field]="'percentage'"></p-sortIcon>
	                     </th>
	                     <th>{{ 'common.actions' | hisUi }}</th>
	                 </tr>
	             </ng-template>
	             <ng-template pTemplate="body" let-inventor let-index="rowIndex">
	                 <tr>
	                     <td>
	                         <span *ngIf="inventor.person">{{inventor.person.surname}}</span>
	                     </td>
	                     <td>
	                         <span *ngIf="inventor.person">{{inventor.person.firstname}}</span>
	                     </td>
	
	                     <td class="singleLine">
	                         <!-- editable for priority patent -->
	                         <div *ngIf="inventor.person">
	                             <!-- for person with internal organization -->
	                             <span *ngIf="inventor.organization">{{inventor.organization.text}}</span>
	                             <!-- for person with external organization / research partner -->
	                             <span *ngIf="inventor.researchPartner">{{inventor.researchPartner.defaulttext}}</span>
	                         </div>
	                     </td>
	
	                     <!-- editable for priority patent -->
	                     <td class="singleLine">
                                {{formatPercentage(inventor.percentage)}}
	                     </td>
	                     <td class="singleLine" >
                             <button (click)="editInventor(inventor)" hisImage="PENCIL" class="icon"
                                title="{{'common.editAssignmentOf' | hisUi:(inventor.person.firstname+' '+inventor.person.surname)}}">
                             </button>
	                         <button *ngIf="inventor.person" (click)="deleteInventor(inventor)" hisImage="DELETE" class="icon"
                                title="{{'common.removeAssignmentOf' | hisUi:(inventor.person.firstname+' '+inventor.person.surname)}}">
                             </button>
	                     </td>
	                 </tr>
	             </ng-template>
	         </p-table>
	             <div class="infoMessage" *ngIf="patent.inventors">
                    <span>{{'fs.res.patent.inventors.percentage.infoMessage'|hisUi}}</span>
                 </div>  
	             <button (click)="percentageOverride()" hisImage="PERCENT"
	                     class="transparent">
	                 <span>{{ 'fs.res.patent.percentageAuto' | hisUi }}</span>
	             </button>
                 <div class="clearer"></div>
	     </div>
	     <ng-template #priorityPatentInventors>
	         <div *ngIf="patent.priorityPatent && patent.priorityPatent.inventors">
			     <h4>{{ 'fs.res.patent.assignedInventors' | hisUi }}</h4>
		         <p-table [value]="patent.priorityPatent.inventors" [paginator]="false">
		            <ng-template pTemplate="header">
		                <tr>
		                    <th>{{ 'fs.res.patent.Patent.inventor.surname' | hisUi }}</th>
		                    <th>{{ 'fs.res.patent.Patent.inventor.firstname' | hisUi }}</th>
		                    <th>{{ 'fs.res.patent.Patent.inventor.organizationUnit' | hisUi }}</th>
		                    <th>{{ 'fs.res.patent.Patent.inventor.percentage' | hisUi }}</th>
		                </tr>
		            </ng-template>
		            <ng-template pTemplate="body" let-inventor>
		                <tr>
		                    <td>{{inventor.person.surname}}</td>
		                    <td>{{inventor.person.firstname}}</td>
		                    <td>{{inventor.organization ? inventor.organization.text : inventor.researchPartner ? inventor.researchPartner.defaulttext : '' }}</td>
		                    <td>{{inventor.percentage | hisAmount}}</td>
		                </tr>
		            </ng-template>
	            </p-table>
            </div>
	     </ng-template>
	
	     <!-- #anchor dynamic field container -->
	     <ng-template #dynamicFieldContainer></ng-template>
	     
	</p-panel>
</div>

<!-- search and assign internal person with percentage -->
<res-patent-internal-inventor-wizard *ngIf="internalInventorVisibility" [(visibility)]="internalInventorVisibility"
   [patentInventor]="patentInventor"
   (savePatentInventorChange)="savePatentInventorChange($event)">
</res-patent-internal-inventor-wizard>
 
<!-- cerate/edit external person/inventor with organization and percentage -->
<res-patent-external-inventor-dialog *ngIf="externalInventorVisibility" [(visibility)]="externalInventorVisibility"
   [patentInventor]="patentInventor"
   (savePatentInventorChange)="savePatentInventorChange($event)">
</res-patent-external-inventor-dialog>

<!-- confirmation dialog if percentage values should be overridden -->
<res-confirmation-dialog></res-confirmation-dialog>
